import { render } from "./vendors-list-modal.vue?vue&type=template&id=a8bfe08a&scoped=true"
import script from "./vendors-list-modal.vue?vue&type=script&lang=js"
export * from "./vendors-list-modal.vue?vue&type=script&lang=js"

import "./vendors-list-modal.vue?vue&type=style&index=0&id=a8bfe08a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8bfe08a"]])

export default __exports__